import {
    apiRequest,
    employeeWFHCreate,
    employeeWFHCheckDate,
    getMaxDate,
    employeeList,
    employeeWFHCheckNumber
} from "../../../../../services/adapters/kepegawaian/employeeWFHService"

class CreateRepository {

    fetchCreate = async (query) => {
        return await apiRequest("post", employeeWFHCreate, {
            body: query
        }, true)
    }

    fetchCheckDate = async (query) => {
        return await apiRequest("post", employeeWFHCheckDate, {
            body: query
        }, true)
    }

    fetchMaxDate = async (query) => {
        return await apiRequest("get", getMaxDate, {
            params: query
        }, true)
    }

    fetchEmployee = async (query) => {
        return await apiRequest("get", employeeList, {
            params: query
        }, true)
    }

    fetchCheckNumber = async (query) => {
        return await apiRequest("post", employeeWFHCheckNumber, {
            body: query
        }, true)
    }
}

export default CreateRepository